import { render } from "./MultiLanguageDropdown.vue?vue&type=template&id=5cef36cd"
import script from "./MultiLanguageDropdown.ts?vue&type=script&lang=js"
export * from "./MultiLanguageDropdown.ts?vue&type=script&lang=js"

import "./MultiLanguageDropdown.vue?vue&type=style&index=0&id=5cef36cd&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__